import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import RenderComponents from "../../RenderByType/RenderComponents";

const ToolBarDropAria = ({path, component, parentIndex, panelIndex}) => {
    const {onDropComponent, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const [{isOverCurrent, canDrop}, drop] = useDrop({
        accept: AcceptTypes.listToolBar,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
            canDrop: monitor.canDrop()
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return;
            }
            if (item.dragType === 'move') {
                onMoveComponent(item.component, item.from, `${path}.children.${panelIndex}.children`, 0, item.index, parentIndex);
                return
            }
            onDropComponent(item, 0, `${path}.children.${panelIndex}.children`)
        }
    });
    return (
        <div
            ref={drop}
            style={{
                border: '1px dashed',
                borderColor: isOverCurrent && canDrop ? 'green' : "#ebebeb",
                margin: '5px 0 5px 0',
                minHeight: 30,
                minWidth: component && component.length > 0 ? 'auto' : 100,
                display: 'flex'
            }}
        >
            {component.map((item, componentIndex) => (
                <RenderComponents
                    path={`${path}.children.${panelIndex}.children.${componentIndex}`}
                    type={item.type}
                    parentPath={`${path}.children.${panelIndex}`}
                    index={componentIndex}
                    item={item}
                />
            ))}
        </div>
    );
};

export default ToolBarDropAria;
ToolBarDropAria.propTypes = {
    path: PropTypes.string,
    component: PropTypes.array,
    parentIndex: PropTypes.number,
    panelIndex: PropTypes.number
};
ToolBarDropAria.defaultProps = {
   component: []
};